(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker-split"] && !Shopify.designMode) return;
  try {
    (function () {
    var MAP = {
      'XXS': '2X Small',
      'XS': 'X Small',
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'X Large',
      'XXL': '2X Large',
      '2XL': '2X Large',
      '2X': '2X Large',
      'XXXL': '3X Large',
      '3XL': '3X Large',
      '3X': '3X Large',
      '4XL': '4X Large'
    };

    function expand(value) {
      var key = (value || '').trim().toUpperCase();
      return MAP[key] || value;
    }

    function update(root) {
      /* display-only NZ spelling: "Color" -> "Colour" (option data untouched) */
      root.querySelectorAll('.variant-colour-label__name').forEach(function (name) {
        if (/^colou?r:?$/i.test(name.textContent.trim())) {
          if (name.textContent !== 'Colour:') name.textContent = 'Colour:';
        }
      });

      root.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        var checked = fieldset.querySelector('input:checked');
        if (!legend || !checked) return;
        /* trim whitespace Horizon leaves in the legend, so "Size" + ":" sit flush */
        legend.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && /\s$/.test(node.textContent)) {
            node.textContent = node.textContent.replace(/\s+$/, '');
          }
        });
        var span = legend.querySelector('.vps-size-value');
        if (!span) {
          span = document.createElement('span');
          span.className = 'vps-size-value';
          legend.appendChild(span);
        }
        var name = expand(checked.value);
        if (span.textContent !== name) span.textContent = name;
      });
    }

    function init() {
      document.querySelectorAll('.vp-split').forEach(function (root) {
        update(root);
        root.addEventListener('change', function () {
          update(root);
        });
        /* section re-renders on variant change replace the DOM — re-apply */
        new MutationObserver(function () {
          update(root);
        }).observe(root, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var MAP = {
      'XXS': '2X Small',
      'XS': 'X Small',
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'X Large',
      'XXL': '2X Large',
      '2XL': '2X Large',
      '2X': '2X Large',
      'XXXL': '3X Large',
      '3XL': '3X Large',
      '3X': '3X Large',
      '4XL': '4X Large'
    };

    function expand(value) {
      var key = (value || '').trim().toUpperCase();
      return MAP[key] || value;
    }

    function update(root) {
      /* display-only NZ spelling: "Color" -> "Colour" (option data untouched) */
      root.querySelectorAll('.variant-colour-label__name').forEach(function (name) {
        if (/^colou?r:?$/i.test(name.textContent.trim())) {
          if (name.textContent !== 'Colour:') name.textContent = 'Colour:';
        }
      });

      root.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        var checked = fieldset.querySelector('input:checked');
        if (!legend || !checked) return;
        /* trim whitespace Horizon leaves in the legend, so "Size" + ":" sit flush */
        legend.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && /\s$/.test(node.textContent)) {
            node.textContent = node.textContent.replace(/\s+$/, '');
          }
        });
        var span = legend.querySelector('.vps-size-value');
        if (!span) {
          span = document.createElement('span');
          span.className = 'vps-size-value';
          legend.appendChild(span);
        }
        var name = expand(checked.value);
        if (span.textContent !== name) span.textContent = name;
      });
    }

    function init() {
      document.querySelectorAll('.vp-split').forEach(function (root) {
        update(root);
        root.addEventListener('change', function () {
          update(root);
        });
        /* section re-renders on variant change replace the DOM — re-apply */
        new MutationObserver(function () {
          update(root);
        }).observe(root, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
